import { ComponentProps } from 'react';
import OverlaySpinner from '@/components/OverlaySpinner';
import { EnrollmentAppProps } from '@/pages/_app';
import useMVIndexRedirect from '@/components/hooks/useMVIndexRedirect';

function Vertical({
  userCareSession,
  hasCSCSessionCookie,
}: ComponentProps<EnrollmentAppProps['Component']>) {
  useMVIndexRedirect({ userCareSession, hasCSCSessionCookie });

  return <OverlaySpinner isOpen wrapped data-testid="loader" />;
}

export default Vertical;
